(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["all-producers"]) return;
  try {
    
  (function () {
    if (window.__sipGrowerAnchorsBound) return;
    window.__sipGrowerAnchorsBound = true;

    function growerAnchorTarget(hash, owner) {
      if (!hash || hash.charAt(0) !== '#') return null;
      var id;
      try { id = decodeURIComponent(hash.slice(1)); } catch (error) { return null; }
      var target = document.getElementById(id);
      if (!target) return null;
      var root = target.closest('[data-sip-growers]');
      return root && (!owner || owner === root) ? target : null;
    }

    function revealGrowerHash() {
      var target = growerAnchorTarget(window.location.hash);
      if (!target) return;
      var directory = target.closest('[data-sip-grower-directory]');
      if (directory && !directory.open) {
        directory.open = true;
        requestAnimationFrame(function () { target.scrollIntoView({ block: 'start' }); });
      }
    }

    document.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var origin = event.target.nodeType === 1 ? event.target : event.target.parentElement;
      var link = origin && origin.closest('.sip-growers__alphabet a[href^="#"]');
      if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
      var owner = link.closest('[data-sip-growers]');
      var target = growerAnchorTarget(link.getAttribute('href'), owner);
      if (!owner || !target) return;
      var directory = target.closest('[data-sip-grower-directory]');
      if (directory) directory.open = true;
      // Keep native fragment navigation; the theme's body delegate otherwise scrolls closed content and cancels the hash.
      event.stopPropagation();
    }, true);

    window.addEventListener('hashchange', revealGrowerHash);
    document.addEventListener('shopify:section:load', revealGrowerHash);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', revealGrowerHash, { once: true });
    } else {
      revealGrowerHash();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-tab-slideshow"] && !Shopify.designMode) return;
  try {
    
function activateSipAboutTab(button) {
  var section = button && button.closest('[data-sip-about-tabs]');
  if (!section || button.disabled) return;
  var selected = button.getAttribute('data-sip-tab-id');
  var panels = Array.from(section.querySelectorAll('.tab-content[data-sip-tab-panel]')).filter(function (item) {
    return item.closest('[data-sip-about-tabs]') === section;
  });
  if (!panels.some(function (item) { return item.getAttribute('data-sip-tab-panel') === selected; })) return;
  section.querySelectorAll('button.tab-title[data-sip-tab-id]').forEach(function (item) {
    if (item.closest('[data-sip-about-tabs]') !== section) return;
    var active = item.getAttribute('data-sip-tab-id') === selected;
    item.classList.toggle('active', active);
    item.setAttribute('aria-pressed', String(active));
  });
  panels.forEach(function (item) {
    item.classList.toggle('active', item.getAttribute('data-sip-tab-panel') === selected);
  });
}

document.addEventListener('click', function (event) {
  var origin = event.target && (event.target.nodeType === 1 ? event.target : event.target.parentElement);
  activateSipAboutTab(origin && origin.closest('button.tab-title[data-sip-tab-id]'));
});

document.addEventListener('shopify:block:select', function (event) {
  var origin = event.target && (event.target.nodeType === 1 ? event.target : event.target.parentElement);
  var section = origin && origin.closest('[data-sip-about-tabs]');
  if (!section || !event.detail || !event.detail.blockId) return;
  var button = Array.from(section.querySelectorAll('button.tab-title[data-sip-tab-id]')).find(function (item) {
    return item.closest('[data-sip-about-tabs]') === section && item.getAttribute('data-sip-tab-id') === event.detail.blockId;
  });
  activateSipAboutTab(button);
});

  } catch(e) { console.error(e); }
})();
})();
